var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconeRel3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23.5,
    cy: 23.5,
    r: 23.5,
    fill: "#212121"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 13C17.7103 13 13 17.7103 13 23.5C13 29.2897 17.7103 34 23.5 34C29.2897 34 34 29.2897 34 23.5C34 17.7103 29.2897 13 23.5 13ZM15.1 23.5C15.1 21.5617 15.7657 19.7809 16.8724 18.3581L28.6418 30.1276C27.174 31.2761 25.3638 31.9001 23.5 31.9C18.8684 31.9 15.1 28.1315 15.1 23.5ZM30.1276 28.6418L18.3581 16.8724C19.8261 15.724 21.6362 15.1001 23.5 15.1C28.1315 15.1 31.9 18.8684 31.9 23.5C31.8995 25.3637 31.2756 27.1737 30.1276 28.6418Z",
    fill: "#339C89"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconeRel3);
export default __webpack_public_path__ + "static/media/icone-rel-3.da958b50f38588747e39081884f5d99b.svg";
export { ForwardRef as ReactComponent };